import gql from 'graphql-tag';

import client from '../graphqlAPI';

const GET_COUPON_TYPES_QUERY = gql`
  query Get {
    getCouponTypes {
      couponTypeId
      couponName
      total
    }
  }
`;

const getCouponTypes = async (slugName, productGroup) => {
  try {
    const result = await client
      .query({
        query: GET_COUPON_TYPES_QUERY,
        fetchPolicy: 'no-cache',
        variables: { slugName, productGroup },
      })
      .then(queryResult => queryResult)
      .catch((queryError) => {
        console.log('\x1b[31m%s\x1b[0m', `${new Date().toLocaleTimeString()} ~ Client: Apollo Client Query Error: ${queryError}`);
        return null;
      });
    const {
      data: { getCouponTypes: getCouponTypesData },
    } = result;

    if (getCouponTypesData) {
      return getCouponTypesData;
    }
    console.log('\x1b[31m%s\x1b[0m', `${new Date().toLocaleTimeString()} ~ Client: GraphQL Query Error: getCouponTypes`);
    return null;
  } catch (error) {
    console.log('\x1b[31m%s\x1b[0m', `${new Date().toLocaleTimeString()} ~ Client: getCouponTypes Error: ${error}`);
    return null;
  }
};

export default getCouponTypes;
